export type ConfigErrorCode =
  | "CONFIG_UNKNOWN_ENVIRONMENT"
  | "CONFIG_MISSING_APP_NAME"
  | "CONFIG_INVALID_APP_NAME"
  | "CONFIG_INVALID_URL"
  | "CONFIG_OVERRIDE_IN_DEPLOYED_MODE"
  | "CONFIG_LEGACY_VITE_ENV";

export class ConfigError extends Error {
  readonly code: ConfigErrorCode;

  constructor(code: ConfigErrorCode, message: string) {
    super(`${code}: ${message}`);
    this.name = "ConfigError";
    this.code = code;
  }
}
